import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Mic, MicOff, Bot, Download } from 'lucide-react';
import { dictateMoisture } from '../lib/agentApp';
import { kritisOn } from '../lib/policy';
import { listen, appLang, OFFLINE_LANGS, hasOfflineModel, fetchOfflineModel, numberGrammar } from '../lib/voiceInput';

// voice input for the moisture grid: own offline recognition (de/en) or the device recognition – no agent, free
const LOC = { de: 'de-DE', en: 'en-US', it: 'it-IT', es: 'es-ES', pt: 'pt-PT', fr: 'fr-FR', sq: 'sq-AL' };
let ac;
export const beep = () => {
  try {
    ac = ac || new (window.AudioContext || window.webkitAudioContext)();
    const o = ac.createOscillator(), g = ac.createGain();
    o.frequency.value = 880; g.gain.value = 0.15; o.connect(g); g.connect(ac.destination); o.start(); o.stop(ac.currentTime + 0.08);
  } catch { /* no audio */ }
};
const say = (txt) => { try { const u = new SpeechSynthesisUtterance(txt); u.lang = LOC[appLang()] || 'de-DE'; window.speechSynthesis.speak(u); } catch { /* no tts */ } };
export const voiceErr = (t, e) => ({ kritis: t.moVoiceKritis, noModel: t.moVoiceNoModel }[e?.message || e] || t.moVoiceNo);

// start/stop wrapper shared by moisture and pressure voice input
export function useVoice(t, heard, grammar, hint) {
  const [on, setOn] = useState(false);
  const ctl = useRef(null);
  const stop = () => { ctl.current?.stop(); ctl.current = null; setOn(false); };
  useEffect(() => () => ctl.current?.stop(), []);
  const start = async () => {
    setOn(true);
    try {
      ctl.current = await listen({ onText: (s) => heard(s, stop), onError: (e) => { toast.error(voiceErr(t, e)); stop(); }, onLoad: () => toast.message(t.moVoiceLoad, { duration: 8000 }), grammar });
      toast.message(`${hint || t.moVoiceHint}${ctl.current.engine === 'offline' ? ` (${t.moVoiceOffline})` : ''}`);
    } catch (e) { toast.error(voiceErr(t, e)); setOn(false); }
  };
  return { on, toggle: on ? stop : start };
}

export default function MoistVoice({ t }) {
  const { on, toggle } = useVoice(t, (text, stop) => {
    const r = dictateMoisture(text, true);
    if (!r) return;
    beep();
    if (r.full) { say(t.moVoiceDone); toast.success(t.moVoiceDone); stop(); } else if (r.newRow) say(`${t.moRow} ${r.newRow}`);
  }, numberGrammar);
  const [pkg, setPkg] = useState(null);
  useEffect(() => { if (OFFLINE_LANGS.includes(appLang())) hasOfflineModel().then(setPkg); }, []);
  const load = async () => { try { await fetchOfflineModel(() => toast.message(t.moVoiceLoad, { duration: 8000 })); setPkg(true); toast.success(t.moVoiceOffline); } catch (e) { toast.error(voiceErr(t, e)); } };
  return (
    <div className="mo-voice" data-testid="moist-voice">
      <button className={`btn btn-sm btn-primary ${on ? 'rec' : ''}`} data-testid="moist-voice-btn" onClick={toggle}>{on ? <MicOff size={14} /> : <Mic size={14} />} {on ? t.moVoiceStop : t.moVoice}</button>
      {pkg === false && <button className="btn btn-outline btn-sm" data-testid="moist-voice-offline-btn" onClick={load}><Download size={14} /> {t.moVoicePkg}</button>}
      {!kritisOn() && document.querySelector('[data-testid="leakbuster-btn"]') && <button className="btn btn-outline btn-sm" data-testid="moist-voice-agent-btn" onClick={() => window.dispatchEvent(new Event('giss-agent-open'))}><Bot size={14} /> {t.moVoiceAgent}</button>}
    </div>
  );
}
